import APIUtils from './APIUtils';

class DashboardAPI {
    static getDashboard() {
        return APIUtils.POST('/api/home/dashboard', {}).then(response => {
            return response.data;
        });
    }

    static getNaviBillInfo() {
        return APIUtils.POST('/api/home/dashboard/agent_info', {}).then(response => {
            return response.data;
        });
    }

    static getDeviceReport(data) {
        return APIUtils.POST('/api/home/device_report', data)
            .then(response => response);
    }

    static getStatistics(data) {
        return APIUtils.POST('/api/home/statistics', data)
            .then(response => response);
    }

    static getProviderPlatformList(data) {
        return APIUtils.POST('/api/home/provider_platform_list', data)
            .then(response => response.data);
    }

    static getDataHomeReport(data, type, format = 'xlsx') {
        return APIUtils.POST(`/api/home/${type}/${format}/report`, data, format)
            .then(response => response);
    }
    static getOnlineMemberList(data) {
        return APIUtils.POST('/api/home/dashboard/online_member_list', data)
            .then(response => response);
    }
}

export default DashboardAPI;
